module.exports = __webpack_public_path__ + "static/media/missingProduct.f8a1c6fa.svg";